// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Xg","summaryPar":"Yg","ratingCategories":"Zg","reviewerInfo":"_g","reviewTypes":"ah","expanded":"bh"};